<template>
  <div class="page-view">
	  <div class="container">    
      <h3 class="title">
        <span >Giới thiệu</span>
      </h3>
      <div class="clearfix"></div>
      <hr>
      <div class="row">
        <div class="col-lg-12 col-md-12 offset-md-1 col-xs-12 margin-top-20">
          <div v-if="page" v-html="parse(page.body)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_PAGE } from '@/store/actions.type';
import util from "@/common/util";

export default {
  name: "RwvIntroduce",
  components: {
  },
  mounted() {   
     this.$store.dispatch(FETCH_PAGE, "gioi-thieu" );
  },
  computed: {
    ...mapGetters(["page"])
  },
  methods: {
    parse(body) {
      return body ? util.parseMarkdown(body) : "";
    }
  }
};
</script>
